import React from "react";
import Header from "./Header";
import HeaderMobile from "./newHeaderMobil";
import HeaderPage from "./../components/common/HeaderPage";
import NewFooter from "./newFooter";
import { Container } from "@material-ui/core";
import Hidden from "@material-ui/core/Hidden";
import ScrollToTop from "./ScrollToTop/ScrollToTop";
import Layout from ".";

export default function ErrorPage404({ home }) {
  return (
    <Layout>
      <div
        className="d-flex  flex-column flex-root"
        style={{
          width: "100%",
          height: "59vh",
          zIndex: "10000000",
          border: "1px solid rgba(0,0,0,0.1)",
        }}
      >
        <div
          className="d-flex flex-row-fluid flex-column p-5 w-100 h-100 text-center align-items-center justify-content-start"
          style={{
            backgroundImage: `url("/assets/images/bg1.jpg")`,
            backgroundPosition: "left",
          }}
        >
          <h1 className="" style={{ fontSize: "100px" }}>
            404
          </h1>
          <h3 className="">صفحه مورد نظر یافت نشد.</h3>
          <h5 className="">
            <a className="text-danger" href="/">
              {" "}
              بازگشت به صفحه اصلی{" "}
            </a>
          </h5>
        </div>
      </div>
      <ScrollToTop />
    </Layout>
  );
}
